// Libs
import React from 'react'

// CSS
import './styles.scss'

const SearchFilter = ({ fields, onClick }) => {
  let defaultFields = [
    { name: 'Caso', value: 'id' },
    { name: 'Processo', value: 'lawsuit.*' },
    { name: 'Código Sistema', value: 'system_code.*' },
    { name: 'Parte', value: 'client.*' },
    { name: 'Advogado', value: 'lawyer.*' },
    { name: 'Empresa', value: 'company.*' },
    { name: 'Escritório', value: 'law_firm.*' }
  ]

  const sourceExists = (value) => {
    return fields.some(field => {
      return field === value;
    });
  }

  return (
    <div className="search-filter">
      <p>Filtrar por:</p>
      <ul>
        {defaultFields.map(defaultField => (
          <li
            key={defaultField.value}
            className="search-filter__field"
            onClick={() => onClick(defaultField.value)}>
            <span className={
              sourceExists(defaultField.value) ?
                "search-filter__checkbox search-filter__checkbox--checked" :
                "search-filter__checkbox"
            } />
            {defaultField.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SearchFilter
